"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkTypes = void 0;
var LinkTypes;
exports.LinkTypes = LinkTypes;

(function (LinkTypes) {
  LinkTypes["PRIMARY"] = "primary";
  LinkTypes["SECONDARY"] = "secondary";
  LinkTypes["INVERSE"] = "inverse";
  LinkTypes["ACTION"] = "action";
  LinkTypes["INLINE"] = "inline";
})(LinkTypes || (exports.LinkTypes = LinkTypes = {}));